"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toInvestorsTabsSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toInvestorsTabsSlice = function (data, logger) {
    var tabs = data.items
        .map(function (item) { return toTab(item, logger); })
        .filter(Boolean);
    // Test des champs obligatoires
    if (!(tabs === null || tabs === void 0 ? void 0 : tabs.length)) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.InvestorsTabs)), { tabs: tabs }));
};
exports.toInvestorsTabsSlice = toInvestorsTabsSlice;
var toTab = function (data, logger) {
    var title = logger.required(fields_1.toText(data.title));
    var content = logger.required(fields_1.toDocumentLink(data.content, logger));
    // Test des champs obligatoires
    if (!(title && content)) {
        return undefined;
    }
    return { title: title, content: content };
};
//# sourceMappingURL=investors-tabs-slice.js.map